import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { AirlineComponent } from '../airline/airline.component';

@Component({
  selector: 'app-airline-list',
  templateUrl: './airline-list.component.html',
  styleUrls: ['./airline-list.component.css']
}) 
export class AirlineListComponent implements OnInit {

  public menu_item_id = '85';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  displayedColumns = ['airline_name', 'airline_name_en', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<AirlineComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'airline', 'airline_name': '' };

  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {

    let condition = "";

    if (this.model['airline_name'] != '')
      condition += " (`airline_name` LIKE '%" + this.model['airline_name'] +
        "%' OR `airline_name_en` LIKE '%" + this.model['airline_name'] + "%') AND ";

    let query = "SELECT * FROM `airline` WHERE" + condition + " `status` = '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newAirline() {
    this.addDialogRef = this.dialog.open(AirlineComponent, {
      hasBackdrop: false,
      //data: this.dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['status'] == 'success')
          this.search();
      });
  }

  editAirline(row) {
    let dialog_data = {
      'table_name': 'airline', 'airline_id': row.airline_id,
      'airline_name': row.airline_name,
      'airline_name_en': row.airline_name_en, 'comment': row.comment
    };
    this.addDialogRef = this.dialog.open(AirlineComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        this.search();
      });
  }

  delAirline(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'airline_id': row.airline_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          //console.log(data);
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

}
